import { jsxs as g, jsx as i } from "react/jsx-runtime";
import { useState as f, useRef as c } from "react";
import u, { Categories as o } from "emoji-picker-react";
import { Icon as d } from "../../../../components/Icon/index.js";
import { ToolbarButtonEmoji as E, EmojiPickerContainer as k } from "./style.js";
import { useClickOutside as p } from "../../../../hooks/useClickOutside/index.js";
import { FaceLaughWink as b } from "@pelando/fontawesome/icons";
import { useTranslation as C } from "../../../../hooks/useTranslation/index.js";
function O({ onSelect: s }) {
  const { t: e } = C("common"), [t, r] = f(!1), a = c(null), m = c(null);
  p(
    [a, m],
    () => r(!1)
  );
  const n = (j) => {
    s(j);
  }, l = [
    {
      category: o.SMILEYS_PEOPLE,
      name: e("emoji-categories-smileys-people")
    },
    {
      category: o.ANIMALS_NATURE,
      name: e("emoji-categories-animals")
    },
    {
      category: o.FOOD_DRINK,
      name: e("emoji-categories-food-drink")
    },
    {
      category: o.ACTIVITIES,
      name: e("emoji-categories-activities")
    },
    {
      category: o.TRAVEL_PLACES,
      name: e("emoji-categories-travel-places")
    },
    {
      category: o.OBJECTS,
      name: e("emoji-categories-objects")
    },
    {
      category: o.SYMBOLS,
      name: e("emoji-categories-symbols")
    }
  ];
  return /* @__PURE__ */ g("div", { children: [
    /* @__PURE__ */ i(
      E,
      {
        "aria-label": e("emoji-add-aria-label"),
        ref: m,
        "data-testid": "emoji-button",
        onClick: () => {
          r(!t);
        },
        children: /* @__PURE__ */ i(
          d,
          {
            icon: b,
            role: "img",
            "aria-label": e("emoji-button-aria-label")
          }
        )
      }
    ),
    t && /* @__PURE__ */ i(k, { ref: a, "data-testid": "emoji-picker", children: /* @__PURE__ */ i(
      u,
      {
        searchDisabled: !0,
        onEmojiClick: n,
        categories: l
      }
    ) })
  ] });
}
export {
  O as EmojiButton
};
